(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[177],{

/***/ 3299:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-story",
      function () {
        return __webpack_require__(3222);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OurStory; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/common/index.ts + 9 modules
var common = __webpack_require__(108);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/common/icons/GreenBook.tsx
var GreenBook = __webpack_require__(4972);
// EXTERNAL MODULE: ./src/components/common/icons/GreenDog.tsx
var GreenDog = __webpack_require__(6179);
// EXTERNAL MODULE: ./src/components/common/icons/GreenTeam.tsx
var GreenTeam = __webpack_require__(4924);
// EXTERNAL MODULE: ./src/ui/index.ts + 16 modules
var ui = __webpack_require__(4522);
;// CONCATENATED MODULE: ./src/components/ourStory/link-ourdifference.tsx


var LinkOurDifference = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "m-auto grid w-[90%] grid-cols-1 gap-8 py-10 text-center text-base lg:w-[60%]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* TextBold */.DU, {
                className: "text-center text-lg",
                children: "What makes Tucker Tub different from all the big brand manufacturers and young startups?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ButtonWithArrow */.Ub, {
                href: "/our-difference",
                buttonVariant: "primary",
                center: true,
                className: "m-auto w-[100%] lg:max-w-[240px]",
                children: "Our Difference"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ourStory/layout/body.tsx







function OurTeamDescription() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "Made locally in country Victoria, it takes a hard working crew to make and deliver only the best all natural dog food available. We also have a passionate team of regional",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/our-team",
                    className: "font-medium underline",
                    children: "distributors"
                }),
                " ",
                "delivering right to your door."
            ]
        })
    });
}
var BodyContentInfoCardData = [
    {
        id: "1",
        heading: "Our History",
        subheading: "Tucker Tub knows dogs, with more than 25 years of experience making natural dog food.",
        description: "Tucker Tub was founded in 1996 in Broadford, Victoria, when the Spiteri family, Rudi, Loree and\n    Richard, realised the lack of unprocessed food options for their pack of Kelpies. Since\n    then we've never looked back.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenBook/* BookIcon */.v, {})
    },
    {
        id: "2",
        heading: "Our Mission",
        subheading: "Healthy pups and happy pet parents - that's what drives us.",
        description: "Tucker Tub is on a mission to improve the health of millions of Aussie dogs by producing honest all natural dog food made farm fresh in Australia.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenDog/* DogIcon */.I, {})
    },
    {
        id: "3",
        heading: "Our Team",
        subheading: "We're a dedicated team of nutritionists, cooks and all out dog lovers.",
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurTeamDescription, {}),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenTeam/* TeamIcon */.W, {})
    }
];
var BodyContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full bg-colorFourteen py-20 font-haboro-soft text-colorFifteen",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Wrapper */.im, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-auto grid grid-cols-1 gap-[30px] sm:grid-cols-2",
                children: [
                    BodyContentInfoCardData.map(function(card) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* InfoCard */.rJ, {
                            cardData: card
                        }, card.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOurDifference, {})
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/ui/cursive-basic.tsx
var cursive_basic = __webpack_require__(4693);
;// CONCATENATED MODULE: ./src/components/ourStory/layout/head.tsx



var HeadContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* BackgroundWrap */.e_, {
        className: "h-full w-full bg-slide-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* GradientWrap */.Mx, {
            className: "from-colorFourteen via-colorFourteen to-transparent",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CurveBanner */.kq, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Header */.h4, {
                        className: "text-colorFourteen",
                        children: "Our Story"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Wrapper */.im, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[200px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                                    className: "text-colorFifteen",
                                    children: "Tucker Tub"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cursive_basic/* CursiveBasic */.x, {
                                    children: "All natural dog food, made farm fresh"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pt-8 text-colorFifteen",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                            children: "At Tucker Tub, dogs are family. We want what's best for them. That's why your pup's gut health is so important to us."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                            children: "Conventional pet food is full of additives, fillers, and other nutrient-poor ingredients. Some are even harmful to your furry friend's digestive system. Tucker Tub was created to change the way we feed our dogs."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                            children: "We've been crafting dog food using fresh ingredients from local farms in country Victoria since our inception over 25 years ago. As one of the pioneers of natural dog food in Australia, we understand what's best for different breeds - including those with food sensitivities and allergies."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                            children: "With Tucker Tub, you can feel confident you're giving your dog nutritious, natural food that's best for them. That's puppy love."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/ourStory/index.tsx



var OurStoryContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadContent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyContent, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/our-story/index.tsx




function OurStory() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Our Story | Tucker Tub",
                description: "Tucker Tub's Our Story",
                openGraph: {
                    title: "Our Story | Tucker Tub",
                    description: "Tucker Tub's Our Story",
                    url: "https://preview.tuckertub.com.au",
                    type: "website",
                    locale: "en_AU",
                    site_name: "Tucker Tub"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Layout */.Ar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurStoryContent, {})
            })
        ]
    });
};


/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CursiveBasic; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CursiveBasic = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "m-auto font-madelyn text-sliderTitle text-colorSixteen lg:text-blockHeader ".concat(className),
        children: children
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4507,236,5812,8969,9774,2888,179], function() { return __webpack_exec__(3299); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);